import React from "react";

export function ProductFooter(props:any) {
    var product_data = props.product_data;

    var min_page = 0;
    var max_page = 0;
    var curr_page= 0;
    var total_pages= 0;
    if( product_data != null ) {
        min_page = product_data.page_nav.min_page;
        max_page = product_data.page_nav.max_page;
        curr_page= product_data.page_nav.curr_page;
        total_pages= product_data.page_nav.total_pages;
    }

    var bw_class = (props.canGoBW) ? 'nav_btn' : 'nav_btn_disabled';
    var fw_class = (props.canGoFW) ? 'nav_btn' : 'nav_btn_disabled';

    return (
        <div>
            <div className='product--page-nav-footer'>
                <span className="nav_total_amount">{props.product_total} items</span>
                <button onClick={props.navHandler} data-nav-btn="bw" data-nav-curruser={props.curr_user} className={bw_class}>‹</button>
                <input
                    onChange={props.navHandlerInput}
                    data-nav-curruser={props.curr_user}
                    className="nav_input"
                    data-nav-min={min_page}
                    data-nav-max={max_page}
                    name="cur_page"
                    type="text"
                    value={curr_page}
                />
                <span className="nav_total_pages">of {total_pages}</span>
                <button onClick={props.navHandler} data-nav-btn="fw" data-nav-curruser={props.curr_user} className={fw_class}>›</button>
            </div>
        </div>
    )
}